import { Link, useParams } from '@tanstack/react-router';

import { ApiError } from '../api/client';
import { ErrorBanner } from '../components/ErrorBanner';
import { IntelligenceReportView } from '../components/IntelligenceReportView';
import { LoadingState } from '../components/LoadingState';
import { PageHeader } from '../components/PageHeader';
import { useIntelligenceReport } from '../features/intelligence/queries';

/** One earlier report, opened from "Informes anteriores". */
export function InteligenciaInformePage() {
  const { reportId } = useParams({ from: '/inteligencia/$reportId' });
  const reportQuery = useIntelligenceReport(reportId);

  return (
    <main>
      <PageHeader
        title="Informe"
        actions={<Link className="btn small secondary" to="/inteligencia">Volver a Informes</Link>}
      />
      {reportQuery.isLoading ? <LoadingState label="Cargando el informe…" /> : null}
      {reportQuery.isError ? <>
        <ErrorBanner message={errorMessage(reportQuery.error)} />
        <button type="button" className="btn small secondary" disabled={reportQuery.isFetching} onClick={() => void reportQuery.refetch()}>Reintentar informe</button>
      </> : null}
      {reportQuery.data ? <IntelligenceReportView report={reportQuery.data} /> : null}
    </main>
  );
}

function errorMessage(error: unknown): string {
  if (error instanceof ApiError) return error.message;
  return 'No pudimos abrir ese informe.';
}
